module.exports = __webpack_public_path__ + "835fe4a1337ee6a97583176875c6564e.woff";